import { NavLink, useParams } from "react-router-dom";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { dateFormat, formatData, splitMissionName } from "../../../../../services/Utils/functionService";
import ProgressMissionMonitoring from "./ProgressMissionMonitoring";

const CardMission = ({ mission }: any) => {
  const { t } = useTranslation();
  const divRef = useRef<HTMLDivElement>(null);
  const [isFocused, setIsFocused] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [opacity, setOpacity] = useState(0);

  const { idPartner } = useParams();

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!divRef.current || isFocused) return;

    const div = divRef.current;
    const rect = div.getBoundingClientRect();

    setPosition({ x: e.clientX - rect.left, y: e.clientY - rect.top });
  };

  const handleFocus = () => {
    setIsFocused(true);
    setOpacity(1);
  };

  const handleBlur = () => {
    setIsFocused(false);
    setOpacity(0);
  };

  const handleMouseEnter = () => {
    setOpacity(1);
  };

  const handleMouseLeave = () => {
    setOpacity(0);
  };

  let data: any[] = [];
  let dataForLabel: any[] = [];
  let formattedData;

  if (mission?.missions) {
    data = [mission.missions[0]?.value];
    dataForLabel = [mission.missions[1]?.value];
    formattedData = formatData(data, dataForLabel);
  }

  const borderColor =
    mission?.color === "red"
      ? "border-red-200"
      : mission?.color === "yellow"
      ? "border-yellow-300"
      : mission?.color === "lightgreen"
      ? "border-green-200"
      : mission?.color === "green"
      ? "border-green-400"
      : "border-gray-200";

  const cardGradient =
    mission?.color === "red"
      ? "from-red-50 to-red-100/30"
      : mission?.color === "yellow"
      ? "from-yellow-50 to-yellow-100/30"
      : mission?.color === "lightgreen"
      ? "from-green-50 to-green-100/30"
      : mission?.color === "green"
      ? "from-green-50 to-green-200/30"
      : "from-gray-50 to-gray-100/30";

  return (
    <div
      ref={divRef}
      onMouseMove={handleMouseMove}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`relative flex h-[300px] w-11/12 text-center items-center justify-center overflow-hidden border-2 rounded-2xl ${borderColor} bg-gradient-to-br ${cardGradient} shadow-lg hover:shadow-xl transition-all duration-300 ease-out group backdrop-blur-sm`}
    >
      <div
        className="pointer-events-none absolute -inset-px opacity-0 transition-all duration-500 ease-out w-full h-full z-10"
        style={{
          opacity,
          background: `radial-gradient(500px circle at ${position.x}px ${position.y}px,rgba(255,255,255,0.6), transparent 50%)`,
        }}
      />
      <NavLink to={`/partner/${idPartner}/customers/${mission.idCustomer}/missions/${mission.id}/requests`} className="z-20 group-hover:scale-105 transition-transform duration-300 ease-out w-full h-full">
        <div className="flex flex-col items-center justify-center p-3 h-full">
          <div className="text-center mb-3">
            <h3
              className={
                mission?.color === "grey"
                  ? "text-sm font-semibold text-gray-800 leading-tight mb-1"
                  : "text-sm font-semibold text-gray-800 leading-tight mb-1"
              }
            >
              {splitMissionName(mission?.name)}
            </h3>
            <p className="text-xs text-gray-600 font-medium mb-1">
              {t("partner.missionEnd")} : <span className="text-gray-800">{dateFormat(mission?.dueDate)}</span>
            </p>
            <p className="text-xs text-gray-500 italic">
              {mission?.fullName}
            </p>
          </div>
          
          <div className="flex flex-col justify-center items-center flex-1 min-h-0">
            {formattedData ? (
              <ProgressMissionMonitoring data={formattedData} />
            ) : (
              <div className="flex flex-col items-center justify-center text-center">
                <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center mb-2">
                  <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <p className="text-xs text-gray-500 font-medium">
                  {t("partner.noRequestForMission")}
                </p>
              </div>
            )}
          </div>
          
          {formattedData ? (
            <div className="mt-2 p-1 bg-white/50 rounded-lg backdrop-blur-sm border border-white/20">
              <p className="text-xs font-semibold text-gray-700 text-center">
                {t("partner.progress")} : <span className="text-blue-600">{Math.round(mission?.progress)} %</span>
              </p>
            </div>
          ) : null}
        </div>
      </NavLink>
    </div>
  );
};

export default CardMission;
